module.exports = __webpack_public_path__ + "static/media/bt_top_moff_check_normal.69f4ed17.png";